<template>
  <div v-if="images.length">
    <transition-group
      @before-leave="beforeLeave"
      name="list"
      tag="div"
      class="columns is-vcentered is-centered is-marginless"
    >
      <div class="column has-text-right is-1" :key="-1">
        <a v-if="imagesCount > 5" @click="decreaseOffset">
          <b-icon type="is-primary" icon="chevron-left"></b-icon>
        </a>
      </div>
      <a
        class="column has-text-centered list-item is-2"
        @click="openGallery(0)"
        :key="getPictureId(0)"
      >
        <figure class="image is-square">
          <img style="border-radius: 5%" :src="getPicture(0)" alt="" />
        </figure>
      </a>
      <a
        v-if="imagesCount > 1"
        class="column has-text-centered list-item is-2"
        @click="openGallery(1)"
        :key="getPictureId(1)"
      >
        <figure class="image is-square">
          <img style="border-radius: 5%" :src="getPicture(1)" alt="" />
        </figure>
      </a>
      <a
        v-if="imagesCount > 2"
        class="column has-text-centered list-item is-2"
        @click="openGallery(2)"
        :key="getPictureId(2)"
      >
        <figure class="image is-square">
          <img style="border-radius: 5%" :src="getPicture(2)" alt="" />
        </figure>
      </a>
      <a
        v-if="imagesCount > 3"
        class="column has-text-centered list-item is-2"
        @click="openGallery(3)"
        :key="getPictureId(3)"
      >
        <figure class="image is-square">
          <img style="border-radius: 5%" :src="getPicture(3)" alt="" />
        </figure>
      </a>
      <a
        v-if="imagesCount > 4"
        class="column has-text-centered list-item is-2"
        @click="openGallery(4)"
        :key="getPictureId(4)"
      >
        <figure class="image is-square">
          <img style="border-radius: 5%" :src="getPicture(4)" alt="" />
        </figure>
      </a>
      <div class="column has-text-left is-1" :key="-2">
        <a v-if="imagesCount > 5" @click="increaseOffset">
          <b-icon type="is-primary" icon="chevron-right"></b-icon>
        </a>
      </div>
    </transition-group>

    <LightBox
      ref="lightbox"
      :media="lightBoxImages"
      :show-caption="true"
      :show-light-box="false"
    >
    </LightBox>
  </div>
</template>

<script>
import LightBox from 'vue-it-bigger'

export default {
  props: ['images'],
  data () {
    return {
      offset: 0
    }
  },
  computed: {
    imagesCount () {
      return this.images.length
    },
    lightBoxImages () {
      return this.images.map((image) => {
        return {
          src: image.attributes.content.url,
          thumb: image.attributes.content.url,
          caption: image.attributes.caption
        }
      })
    }
  },
  components: {
    LightBox
  },
  methods: {
    openGallery (position) {
      let offetPosition = (position + this.offset) % this.images.length
      this.$refs.lightbox.showImage(offetPosition)
    },
    getPicture (position) {
      let offetPosition = (position + this.offset) % this.images.length
      return this.images[offetPosition].attributes.content.url
    },
    getPictureId (position) {
      let offetPosition = (position + this.offset) % this.images.length
      return this.images[offetPosition].id
    },
    increaseOffset () {
      this.offset = this.offset + 1
    },
    decreaseOffset () {
      if (this.offset === 0) this.offset = this.imagesCount - 1
      else this.offset--
    },
    // Transitions
    beforeLeave (el) {
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  transition: all 1s;
}
.list-move {
  transition: all 1s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}

.list-enter-active {
  transition: opacity 0.3s;
  opacity: 0;
}

.list-leave-active {
  transition: opacity 0.3s;
  opacity: 0;
  position: absolute;
}
.fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>
